//input.js
/* eslint-disable */
const addListener = function(el, type, fn) {
  el.addEventListener(type, fn, false);
};

// 限制只能输入字母数字
const alphanumericFilter = function(el) {
  const regStr = /[^a-zA-Z0-9]/g; // 使用正则表达式过滤非字母和非数字字符
  addListener(el, 'input', () => {
    const newValue = el.value.replace(regStr, ''); // 使用正则表达式过滤非字母和非数字字符
    if (el.value !== newValue) {
      el.value = newValue;
      el.dispatchEvent(new Event('input'));
    }
  });
};

export default {
  bind(el, binding) {
    if (el.tagName.toLowerCase() !== 'input') {
      el = el.getElementsByTagName('input')[0];
    }
    // spaceFilter(el)
    switch (binding.arg) {
      case 'alphanumeric':
        alphanumericFilter(el);
        break;
      default:
        console.warn('未知指令类型', binding.arg);
        break;
    }
  }
};
